/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/no-unknown-property, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useRef } from "react";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import CommonModal from "common/vue/components/CommonModal.react.vue";
import "./SizeChartModal.scss";
import { renderList } from "common/vue/render-list";
import { cn } from "tailwind-variants";

function SizeChartModal({ hideCloseButton = false, onClose, ...restProps }: any) {
  /* TODO(vue-migration): useImperativeHandle on CommonModal for close method */
  const commonModalRef = useRef(null);

  const sizes = [
    {
      size: '10"',
      recommended: "adult-jersey"
    },
    {
      size: '8"',
      recommended: "adult"
    },
    {
      size: '6"',
      recommended: "youth"
    },
    {
      size: '4"',
      recommended: null
    }
  ];

  const products = [
    {
      id: "youth",
      name: "Youth Sizes"
    },
    {
      id: "adult",
      name: "Adult Sizes"
    },
    {
      id: "adult-jersey",
      name: "Adult Jersey Sizes"
    }
  ];

  function closeModal() {
    // @ts-expect-error TS(2339): Property 'close' does not exist on type 'never'.
    commonModalRef.current?.close();
  }

  function handleModalClose() {
    onClose?.();
  }

  return (
    <CommonModal
      {...restProps}
      ref={commonModalRef}
      compact
      hideCloseButton={true}
      bottomAligned
      onClose={handleModalClose}
      data-testid="common-modal"
    >
      <div className="size-chart-modal">
        <div className="size-chart-modal__header-container">
          <div className="size-chart-modal__header">Numbers Size Guide</div>
          {!hideCloseButton ? (
            <button
              className="size-chart-modal__modal-button-close"
              type="button"
              onClick={closeModal}
              data-testid="size-chart-modal-modal-button-close"
            >
              <UseSvg
                className="size-chart-modal__modal-button-close-icon"
                icon="menu-close"
                data-testid="size-chart-modal-modal-button-close-icon"
              />
            </button>
          ) : null}
        </div>
        <div className="size-chart-modal__content">
          <div
            className={cn(
              "size-chart-modal__size-container",
              "size-chart-modal__size-container--label"
            )}
          >
            <h2 className="size-chart-modal__size" />
            {renderList(products, product => (
              <div
                className={cn(
                  "size-chart-modal__product",
                  `size-chart-modal__product--${product.id}`
                )}
                key={product}
              >
                {/* @ts-expect-error TS migration */}
                <div className="size-chart-modal__product-name" s={true}>
                  {product.name}
                </div>
              </div>
            ))}
          </div>
          {renderList(sizes, (size, index) => (
            <div
              className={cn(
                "size-chart-modal__size-container",
                `size-chart-modal__size-container--${size.size.slice(0, -1)}`
              )}
              key={size.size}
            >
              <h2 className="size-chart-modal__size size-chart-modal__size--pill">{size.size}</h2>
              {renderList(products, product => (
                <div
                  className={cn(
                    "size-chart-modal__product",
                    `size-chart-modal__product--${product.id}`
                  )}
                  key={product}
                >
                  <div
                    className={cn("size-chart-modal__product-name", {
                      hidden: index > 0,
                      "size-chart-modal__product-name--inline": index === 0
                    })}
                  >
                    {product.name}
                  </div>
                  <div
                    className={cn(
                      "size-chart-modal__image",
                      `size-chart-modal__image--${size.size.slice(0, -1)}`
                    )}
                  />
                  {size.recommended === product.id ? (
                    <div className="size-chart-modal__image-tag"> RECOMMENDED </div>
                  ) : null}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </CommonModal>
  );
}

export default SizeChartModal;
